import * as React from 'react';
import { Select, Button, Col, Row } from 'antd';
const { Option } = Select;
import { IWidget } from 'common/schema/widget/Widget';
import { getIn, useFormikContext } from 'formik';
import { MenuOutlined, MinusOutlined } from '@ant-design/icons';
import { SelectInput } from 'client/ui/form/input/SelectInput';
import { SelectValue } from 'antd/lib/select';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { useMultiPreferenceSelect } from '../util/useMultiPreferenceSelect';
import { FormItem } from 'client/ui/form/FormItem';
import { WidgetInputRowContentWrapper } from './WidgetInputRowContentWrapper';

interface WidgetInputRowContentProps {
  index: number;
  widget: IWidget;
  request: any;
  handleAdd: any;
  handleRemove: any;
  row?: any;
  cascade: any;
}

/**
 * Contenuto singola riga del widget a preferenza multipla
 */
export function WidgetInputRowContent(props: WidgetInputRowContentProps) {
  const {
    index,
    widget,
    request,
    handleAdd,
    handleRemove,
    cascade,
    row
  } = props;

  const metadata = MetadataLogic.singleFromWidget(widget);
  const fieldPrefix = `values.${metadata.id}.${index}.values`;
  const formik = useFormikContext();
  const fields = useMultiPreferenceSelect(
    cascade,
    metadata.id,
    index,
    fieldPrefix,
    request
  );

  // Ripristino i valori iniziali della riga in caso di modifica di una riga valorizzata
  // Ripristino sia il valore che l'attributo touched per resettare la validation
  function resetFormRow(value: SelectValue, i: number) {
    if (getIn(request, `${fieldPrefix}.${i}`)) {
      for (let j = i; j < fields.length - 1; j++) {
        formik.setFieldValue(`${fieldPrefix}.${j + 1}`, undefined);
        formik.setFieldTouched(`${fieldPrefix}.${j + 1}`, false);
      }
    }
  }

  return (
    <WidgetInputRowContentWrapper
      index={index}
      action={
        <Button
          size="small"
          onClick={() => {
            handleRemove(row);
          }}
          icon={<MinusOutlined />}
        />
      }
    >
      {fields.map((field, i) => (
        <Col>
          <FormItem name={`${fieldPrefix}.${field.field.index}`}>
            <SelectInput
              key={i}
              name={`${fieldPrefix}.${field.field.index}`}
              disabled={field.disabled}
              placeholder={field.field.label ?? `Preferenza ${i + 1}`} // prettier-ignore
              onChange={value => {
                resetFormRow(value, i);
                // Scommentare in caso si voglia gestire l'aggiunta automatica di una nuova riga
                // if (i === fields.length - 1) {
                //   handleAdd();
                // }
              }}
            >
              {field.options.map(option => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </SelectInput>
          </FormItem>
        </Col>
      ))}
    </WidgetInputRowContentWrapper>
  );
}
